export default "<div class=\"row\">\n    <div class=\"col\">\n        <img [src]=\"photo_url\" />\n    </div>\n</div>\n"